import { Time } from "./time";
import { Updatable } from "./updatable";

export class UpdateDispatcher
{    
    private static updatables:Updatable[] = [];
    private static running:boolean = false;    
    private static paused:boolean = false;

    public static add(updatable:Updatable):void
    {
        if (this.updatables.indexOf(updatable) < 0)
        {
            this.updatables.push(updatable);
            updatable.start();
        }

        if (!this.running)
        {
            this.loop();
        }
    }

    public static remove(updatable:Updatable):void
    {
        let i = this.updatables.indexOf(updatable);
        if (i >= 0)
        {
            this.updatables.splice(i, 1);
        }
    }

    private static loop(currentTime:DOMHighResTimeStamp = 0)
    {
        if (currentTime > 0 && !this.paused)
        {
            for (let i = 0; i < this.updatables.length; i++ )
            {
                let u:Updatable = this.updatables[i];
    
                if (u.width != u.container.clientWidth || u.height != u.container.clientHeight)
                {
                    u.resize();
                }
    
                if (Time.update(currentTime))       
                {
                    this.updatables[i].update();
                }
            }    
        }

        requestAnimationFrame( (time) => { UpdateDispatcher.loop(time);});
    }

    public static pause()
    {
        this.paused = true;
    }
}